import { createContext } from 'react';
import type {
  Gender,
  InsuranceCompany,
  ExaminationType,
  Person,
  Employee,
  ExaminingPhysician,
  Applicant,
  PaymentType,
  DeathClassification,
  Diagnosis,
  Toxicologist,
  ProviderDepartment
} from '../../api/referencesApi/ReferencesApi';

export type { Option } from '../toOptions';

export type ReferencesState = {
  genders: Gender[];
  insurances: InsuranceCompany[];
  examinationTypes: ExaminationType[];
  persons: Person[];
  employees: Employee[];
  examiningPhysicians: ExaminingPhysician[];
  applicants: Applicant[];
  paymentTypes: PaymentType[];
  deathClassifications: DeathClassification[];
  diagnoses: Diagnosis[];
  toxicologists: Toxicologist[];
  providerDepartments: ProviderDepartment[];
};

export type ReferencesContextType = {
  references: ReferencesState;
  loading: boolean;
  loadReferences: () => Promise<void>;
};

export const ReferencesContext = createContext<ReferencesContextType | null>(null);
